import React from "react";
import {
  CamelCaseToFirstUpper,
  capitalizeFirstLetterOfEachWord,
} from "../../../Components/Functions/word.fun";
import ClimateGraphs from "./climate_graphs";
import PolyhouseDesignerNew from "../../construction sketch/contruct_designsNew";
import { useState } from "react";
import PolyhouseFrontNew from "../../construction sketch/polyhouseFrontNew";
import PolyhouseCenterNew from "../../construction sketch/polyhouseCenterNew";
import PolyhouseSideNew from "../../construction sketch/polyhoseSideNew";

const SIDetails = ({ data, allQData }) => {
  let serial = 0;
  const degreeToFahrenheit = (value) => {
    value = ((value - 32) * 5) / 9;
    value = Math.round(value);
    return `${value} °C`;
  };
  // polyhouse foundation designer states
  const [BASE_SCALE, setBASE_SCALE] = useState(24); // px per meter (constant scale)
  const [footingDiaM, setFootingDiaM] = useState(0.35); // visual marker only
  const [precision, setPrecision] = useState(2); // decimals in CSV
  const [showGrid, setShowGrid] = useState(true);
  const [showLabels, setShowLabels] = useState(true); // controls **block** labels only
  const [showOutline, setShowOutline] = useState(true);
  const [showBC, setShowBC] = useState(true);
  const [showHC, setShowHC] = useState(true);
  const [entryStartLabel, setEntryStartLabel] = useState(""); // HCn start for entry cabin
  const [hcPairs, setHCPairs] = useState([]);
  const [blockName, setBlockName] = useState([]);

  const images = [
    {
      title: "Entry to Farm",
      src: data?.sunlight?.entryTofarmPhoto,
      alt: "Entry to Farm",
    },
    {
      title: "Layout",
      src: data?.dimensions?.layoutPhoto,
      alt: "Layout",
    },
    {
      title: "North South Measurement",
      src: data?.dimensions?.northSouthMeasurmentPhoto,
      alt: "North South Measurement",
    },
    {
      title: "East West Measurement",
      src: data?.dimensions?.eastWestMeasurmentPhoto,
      alt: "East West Measurement",
    },
    {
      title: "Lux UV Open",
      src: data?.sunlight?.luxUvOpenPhoto,
      alt: "Lux UV Open",
    },
    {
      title: "Obstacles Towards Sky",
      src: data?.land?.obstaclesTowardsSkyPhoto,
      alt: "Obstacles Towards Sky",
    },
    {
      title: "Water Tank Location",
      src: data?.water?.waterTankLocationPhoto,
      alt: "Water Tank Location",
    },
    {
      title: "Water Report",
      src: data?.water?.waterReportPhoto,
      alt: "Water Report",
    },
  ].filter((img) => img.src);

  return (
    <div>
      <h3>Personal / Promoter Details:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {data?.clientDetails?.businessName && (
            <tr>
              <td>{++serial}</td> <td> Business Name</td>
              <td>{data?.clientDetails?.businessName || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.clientName && (
            <tr>
              <td>{++serial}</td> <td> Client Name</td>
              <td>{data?.clientDetails?.clientName || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.clientEmail && (
            <tr>
              <td>{++serial}</td> <td> Email</td>
              <td>{data?.clientDetails?.clientEmail || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.clientContactNumber && (
            <tr>
              <td>{++serial}</td> <td> Phone</td>
              <td>{data?.clientDetails?.clientContactNumber || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.businessGstNumber && (
            <tr>
              <td>{++serial}</td> <td> GST Number</td>
              <td>{data?.clientDetails?.businessGstNumber || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.panNumber && (
            <tr>
              <td>{++serial}</td> <td> PAN</td>
              <td>{data?.clientDetails?.panNumber || "N/A"}</td>
            </tr>
          )}
          {data?.clientDetails?.billingAddress && (
            <tr>
              <td>{++serial}</td> <td> Billing Address</td>
              <td>{data?.clientDetails?.billingAddress || "N/A"}</td>
            </tr>
          )}

          {data?.newSiteInspection?.dateOfBirth && (
            <tr>
              <td>{++serial}</td> <td> Birth Date</td>
              <td>{data?.newSiteInspection?.dateOfBirth || "N/A"}</td>
            </tr>
          )}
          {data?.newSiteInspection?.currentProfession && (
            <tr>
              <td>{++serial}</td> <td>Current Profession</td>
              <td>
                {CamelCaseToFirstUpper(
                  data?.newSiteInspection?.currentProfession
                ) || "N/A"}
              </td>
            </tr>
          )}
          {data?.cast && (
            <tr>
              <td>{++serial}</td> <td>Cast</td>
              <td>{CamelCaseToFirstUpper(data?.cast) || "N/A"}</td>
            </tr>
          )}
          {data?.projectOwnerGender && (
            <tr>
              <td>{++serial}</td> <td>Gender</td>
              <td>
                {CamelCaseToFirstUpper(data?.projectOwnerGender) || "N/A"}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <h3>Inspection & Project Details:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Inspection Date</td>
            <td>{data?.newSiteInspection?.inspectionDate || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Site Address</td>
            <td>
              {data?.newSiteInspection?.siteAddress ||
                data?.newSiteInspection?.siteAddressLine1 ||
                data?.newSiteInspection?.siteAddressLine2 ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Pin Code</td>
            <td> {data?.newSiteInspection?.sitePinCode || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Total Available Area</td>
            <td>
              {data?.newSiteInspection?.totalAvailableAreaNumber
                ? `${data?.newSiteInspection?.totalAvailableAreaNumber} ${data?.newSiteInspection?.totalAvailableAreaUnit}`
                : "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Area</td>
            <td> {allQData?.area_in?.area_in_sqft || "N/A"} sqft</td>
          </tr>
        </tbody>
      </table>
      <h3>Project Site - Staff Details:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Site Manager</td>
            <td> {data?.newSiteInspection?.siteManagerName || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Manager Phone Number</td>
            <td> {data?.newSiteInspection?.siteManagerPhone || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Staff on Site</td>
            <td> {data?.newSiteInspection?.numberOfStaff || "N/A"}</td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <h3>Land Details:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
            <th>Ideal</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td> {(serial = 1)}</td>
            <td> Type of Site</td>
            <td>
              {(data?.newSiteInspection?.typeOfSite &&
                CamelCaseToFirstUpper(data?.newSiteInspection?.typeOfSite)) ||
                "N/A"}
            </td>
            <td> Any</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Soil Type</td>
            <td>
              {(data?.newSiteInspection?.soilType &&
                CamelCaseToFirstUpper(data?.newSiteInspection?.soilType)) ||
                "N/A"}
            </td>
            <td>Any</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Land Ownership</td>
            <td>
              {(data?.newSiteInspection?.landOwnership &&
                CamelCaseToFirstUpper(
                  data?.newSiteInspection?.landOwnership
                )) ||
                "N/A"}
            </td>
            <td>Any</td>
          </tr>
          {data?.land?.landFencingHeightInFeet &&
            data?.land?.landFencingHeightInFeet != 0 && (
              <>
                <tr>
                  <td> {++serial}</td>
                  <td>Land Fencing Height In Feet</td>
                  <td>
                    {(data?.land?.landFencingHeightInFeet &&
                      CamelCaseToFirstUpper(
                        data?.land?.landFencingHeightInFeet
                      )) ||
                      "N/A"}
                  </td>
                  <td>0</td>
                </tr>
                <tr>
                  <td> {++serial}</td>
                  <td>Land Fencing Type</td>
                  <td>
                    {(data?.land?.landFencingType &&
                      CamelCaseToFirstUpper(data?.land?.landFencingType)) ||
                      "N/A"}
                  </td>
                  <td>Any Fencing</td>
                </tr>
              </>
            )}
          <tr>
            <td> {++serial}</td>
            <td> Land Levelling</td>
            <td>
              {(data?.newSiteInspection?.landLeveling &&
                CamelCaseToFirstUpper(data?.newSiteInspection?.landLeveling)) ||
                "N/A"}
            </td>
            <td>Required</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Natural Slope of Land</td>
            <td>
              {(data?.newSiteInspection?.naturalSlopeOfLand &&
                CamelCaseToFirstUpper(
                  data?.newSiteInspection?.naturalSlopeOfLand
                )) ||
                "N/A"}
            </td>

            <td>Required</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td>Farm Entry</td>

            <td>
              {(data?.sunlight?.entryToFarmSite &&
                CamelCaseToFirstUpper(data?.sunlight?.entryToFarmSite)) ||
                "N/A"}
            </td>
            <td>Required</td>
          </tr>

          <tr>
            <td> {++serial}</td>
            <td>Lux Uv Open</td>
            <td>{data?.sunlight?.luxUvOpen || "N/A"} </td>
            <td>Above 2000</td>
          </tr>

          <tr>
            <td> {++serial}</td>
            <td> North South Measurement</td>
            <td> {data?.dimensions?.northSouthMeasurmentInMeter || "N/A"} </td>
            <td>Any</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> East West Measurement</td>
            <td>{data?.dimensions?.eastWestMeasurmentInMeter || "N/A"}</td>
            <td> Any</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td>Land Has Hil Lock</td>
            <td> {data?.land?.landHasHillock ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td>Land Has Mud Patch</td>
            <td> {data?.land?.landHasMudPatch ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td>Land Has Pond</td>
            <td> {data?.land?.landHasPond ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td>Land Has Stones</td>
            <td> {data?.land?.landHasStones ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Land Has Tree</td>
            <td> {data?.land?.landHasTree ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Obstacles Towards Sky</td>
            <td> {data?.land?.obstaclesTowardsSky ? "Yes" : "No"}</td>
            <td>No</td>
          </tr>
          <tr>
            <td> {++serial}</td>
            <td> Landmark (latitude,longitude)</td>
            <td> {data?.land?.googleMapsLocationLink || "N/A"}</td>
            <td>ANY</td>
          </tr>
        </tbody>
      </table>
      {data?.land?.googleMapsLocationLink && (
        <>
          {" "}
          <h3>Landmark:</h3>
          <br />
          <div
            style={{
              justifyItems: "center",
            }}
          >
            <div class="mapouter" style={{ width: "90%" }}>
              <div class="gmap_canvas">
                <iframe
                  src={`https://maps.google.com/maps?q=${data?.land?.googleMapsLocationLink}&t=k&z=19&ie=UTF8&iwloc=&output=embed`}
                  width="100%"
                  height="450px"
                  id="gmap_canvas"
                  frameborder="0"
                  scrolling="yes"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
            </div>
          </div>
        </>
      )}
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <h3>Farm Details:</h3>
      {Array.from({ length: Math.ceil(images.length / 2) }).map(
        (_, rowIndex) => {
          const left = images[rowIndex * 2];
          const right = images[rowIndex * 2 + 1];

          return (
            <table
              key={rowIndex}
              className="images-table"
              style={{
                width: "100%",
                pageBreakInside: "avoid",
                marginBottom: 15,
              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: "50%", fontWeight: "bold" }}>
                    {left?.title}
                  </td>
                  {right && (
                    <td style={{ width: "50%", fontWeight: "bold" }}>
                      {right?.title || ""}
                    </td>
                  )}
                </tr>

                <tr>
                  <td style={{ textAlign: "center", padding: 5 }}>
                    {left && (
                      <img
                        src={left.src}
                        alt={left.alt}
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          maxHeight: "450px",
                          objectPosition: "center",
                          display: "block",
                        }}
                      />
                    )}
                  </td>

                  {right?.src && (
                    <td style={{ textAlign: "center", padding: 5 }}>
                      {right && (
                        <img
                          src={right.src}
                          alt={right.alt}
                          style={{
                            objectFit: "contain",
                            width: "100%",
                            maxHeight: "450px",
                            objectPosition: "center",
                            display: "block",
                          }}
                        />
                      )}
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          );
        }
      )}
      {/* {data?.dimensions?.pEndView && (
        <div>
          <h3>Polyhouse End View :</h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pEndView}
            alt={"Costruction Layout"}
          />
        </div>
      )} */}
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      {data?.dimensions?.pEndView ? (
        <div>
          <h3>Polyhouse End View :</h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pEndView}
            alt={"Costruction Layout"}
          />
        </div>
      ) : (
        <div>
          <h3>Polyhouse End View :</h3>
          <PolyhouseFrontNew
            length={allQData?.input_info?.bay_size}
            width={allQData?.input_info?.span_size}
            BASE_SCALE={BASE_SCALE}
          />
        </div>
      )}
      {/* {data?.dimensions?.pCenterView && (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - center view (No big column) : </h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pCenterView}
            alt={"Costruction Layout"}
          />
        </div>
      )} */}
      {data?.dimensions?.pCenterView ? (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - center view (No big column) : </h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pCenterView}
            alt={"Costruction Layout"}
          />
        </div>
      ) : (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - center view (No big column) :</h3>
          <PolyhouseCenterNew
            length={allQData?.input_info?.bay_size}
            width={allQData?.input_info?.span_size}
            BASE_SCALE={BASE_SCALE}
          />
        </div>
      )}
      {/* {data?.dimensions?.pSideView && (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - side view : </h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pSideView}
            alt={"Costruction Layout"}
          />
        </div>
      )} */}
      {data?.dimensions?.pSideView ? (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - side view : </h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.pSideView}
            alt={"Costruction Layout"}
          />
        </div>
      ) : (
        <div className="mt-3 mb-3">
          <h3>Polyhouse - side view :</h3>
          <PolyhouseSideNew
            length={allQData?.input_info?.bay_size}
            width={allQData?.input_info?.span_size}
            BASE_SCALE={BASE_SCALE}
          />
        </div>
      )}
      {/* 
      {data?.dimensions?.costructionLayout && (
        <div className="mt-3 mb-3">
          <h3>Polyhouse Layout :</h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.costructionLayout}
            alt={"Costruction Layout"}
          />
        </div>
      )} */}
      {data?.dimensions?.costructionLayout ? (
        <div className="mt-3 mb-3">
          <div
            className="html2pdf__page-break"
            style={{
              pageBreakAfter: "always",
              display: "block",
              clear: "both",
            }}
          ></div>
          <h3>Polyhouse Layout :</h3>
          <img
            style={{ margin: "5px", width: "95%" }}
            src={data?.dimensions?.costructionLayout}
            alt={"Costruction Layout"}
          />
          <div
            className="html2pdf__page-break"
            style={{
              pageBreakAfter: "always",
              display: "block",
              clear: "both",
            }}
          ></div>
        </div>
      ) : (
        <div className="mt-3 mb-3">
          <div
            className="html2pdf__page-break"
            style={{
              pageBreakAfter: "always",
              display: "block",
              clear: "both",
            }}
          ></div>
          <PolyhouseDesignerNew
            length={allQData?.input_info?.bay_size}
            BASE_SCALE={BASE_SCALE}
            width={allQData?.input_info?.span_size}
            entryStartLabel={entryStartLabel}
            footingDiaM={footingDiaM}
            precision={precision}
            showGrid={showGrid}
            showLabels={showLabels}
            showOutline={showOutline}
            showBC={showBC}
            showHC={showHC}
            blockName={blockName}
          />
          <div
            className="html2pdf__page-break"
            style={{
              pageBreakAfter: "always",
              display: "block",
              clear: "both",
            }}
          ></div>
        </div>
      )}
      {data?.dimensions?.systemLayout && (
        <table
          style={{ width: "100%", pageBreakInside: "avoid" }}
          className="images-table"
        >
          <tbody>
            <tr>
              <td style={{ width: "50%" }}>System Layout</td>
            </tr>
            <tr>
              <td>
                {data?.dimensions?.systemLayout ? (
                  <img
                    style={{ margin: "5px", width: "95%" }}
                    src={data?.dimensions?.systemLayout}
                    alt={"system Layout"}
                  />
                ) : (
                  "N/A"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {data?.water?.markWaterNotAvailable && (
        <>
          <h3>Water Details:</h3>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "5%" }}>Sr.</th>
                <th style={{ width: "30%" }}>Name</th>
                <th>Result</th>
                <th>Ideal</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{(serial = 1)}</td>
                <td>Water Source</td>
                <td>
                  {(data?.water?.waterSourceType &&
                    CamelCaseToFirstUpper(data?.water?.waterSourceType)) ||
                    "N/A"}
                </td>
                <td>Any</td>
              </tr>
              <tr>
                <td>{++serial}</td>
                <td>Tank / Motor Capacity</td>
                <td>
                  {data?.water?.waterTankCapacityInLitre
                    ? `${data?.water?.waterTankCapacityInLitre}`
                    : "N/A"}
                </td>
                <td> Above 12000 Ltr / 1 Hp</td>
              </tr>
              <tr>
                <td>{++serial}</td>
                <td>Availability Frequency</td>
                <td>
                  {(data?.water?.waterAvailabilityFrequency &&
                    CamelCaseToFirstUpper(
                      data?.water?.waterAvailabilityFrequency
                    )) ||
                    "N/A"}
                </td>
                <td>On Demand</td>
              </tr>
              <tr>
                <td>{++serial}</td>
                <td>Water Tank Position </td>
                <td>
                  {(data?.water?.positionOfWaterTank &&
                    CamelCaseToFirstUpper(data?.water?.positionOfWaterTank)) ||
                    "N/A"}
                </td>
                <td>Any</td>
              </tr>
              <tr>
                <td>{++serial}</td>
                <td>pH Reading</td>
                <td>{data?.water?.waterPhReading || "N/A"}</td>
                <td>4.5 - 8.0</td>
              </tr>
              <tr>
                <td>{++serial}</td>
                <td>EC Reading</td>
                <td>{data?.water?.waterEcReading || "N/A"}</td>
                <td>400 - 1600</td>
              </tr>
            </tbody>
          </table>
          <br />
        </>
      )}

      <div style={{ pageBreakInside: "avoid" }}>
        <h3>Climate Details:</h3>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "30%" }}>Name</th>
              <th>Result</th>
              <th>Date Time Stamp</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Climate Coldest Month</td>
              <td>
                {data?.climate?.climateColdestMonth
                  ? capitalizeFirstLetterOfEachWord(
                      data?.climate?.climateColdestMonth
                    )
                  : "N/A"}
              </td>
              <td> ----- </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Climate Hottest Month</td>
              <td>
                {data?.climate?.climateHottestMonth
                  ? capitalizeFirstLetterOfEachWord(
                      data?.climate?.climateHottestMonth
                    )
                  : "N/A"}
              </td>
              <td> ----- </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Temperature</td>
              <td>
                {data?.climate?.temperatureReading
                  ? degreeToFahrenheit(data?.climate?.temperatureReading)
                  : "N/A"}
              </td>
              <td>{data?.createdAt || "N/A"}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Humidity</td>
              <td>{data?.climate?.humidityReading || "N/A"}</td>
              <td>{data?.createdAt || "N/A"}</td>
            </tr>
          </tbody>
        </table>
        {data && <ClimateGraphs SIData={data} />}
      </div>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <h3>Facilities on Site</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Item Storage</td>
            <td> {data?.facilities?.facilityToStoreItems ? "Yes" : "No"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Labour Stay</td>
            <td>{data?.facilities?.facilityToStay ? "Yes" : "No"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Bathroom</td>
            <td> {data?.facilities?.facilityHasBathroom ? "Yes" : "No"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Drinking Water</td>
            <td>{data?.facilities?.facilityHasDrinkingWater ? "Yes" : "No"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Kitchen Space</td>
            <td>{data?.facilities?.facilityHasDrinkingWater ? "Yes" : "No"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Fuel for Cooking</td>
            <td>
              {data?.facilities?.facilityHasFuelForCooking ? "Yes" : "No"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Internet Connectivity</td>
            <td>
              {(data?.facilities?.internetConnectivity &&
                CamelCaseToFirstUpper(
                  data?.facilities?.internetConnectivity
                )) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Transport Option</td>
            <td>
              {(data?.facilities?.transportOption &&
                CamelCaseToFirstUpper(data?.facilities?.transportOption)) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Tar Road</td>
            <td>{data?.facilities?.nearestTarRoad || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Bus Stand</td>
            <td>{data?.facilities?.nearestBusStand || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Railway Station</td>
            <td>{data?.facilities?.nearestRailwayStation || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Market</td>
            <td>{data?.facilities?.nearestMarket || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Medical Facility</td>
            <td>{data?.facilities?.nearestMedicalFacility || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Airport</td>
            <td>{data?.facilities?.nearestAirport || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Nearest Stay Facility</td>
            <td>{data?.facilities?.nearestStayFacility || "N/A"}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Regular Mode Of Transportation</td>
            <td>
              {(data?.facilities?.regulerModeOfTransportation &&
                CamelCaseToFirstUpper(
                  data?.facilities?.regulerModeOfTransportation
                )) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Vehicle Availability for Emergency</td>
            <td>
              {(data?.facilities?.vehicleAvilableForEmergency &&
                CamelCaseToFirstUpper(
                  data?.facilities?.vehicleAvilableForEmergency
                )) ||
                "N/A"}
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Boundaries</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td> Adjoining North</td>
            <td>
              {(data?.land?.whatsOnNorth &&
                CamelCaseToFirstUpper(data?.land?.whatsOnNorth)) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td> Adjoining East</td>
            <td>
              {(data?.land?.whatsOnEast &&
                CamelCaseToFirstUpper(data?.land?.whatsOnEast)) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td> Adjoining South</td>
            <td>
              {(data?.land?.whatsOnSouth &&
                CamelCaseToFirstUpper(data?.land?.whatsOnSouth)) ||
                "N/A"}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td> Adjoining West</td>
            <td>
              {(data?.land?.whatsOnWest &&
                CamelCaseToFirstUpper(data?.land?.whatsOnWest)) ||
                "N/A"}
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Electricity</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Name</th>
            <th>Result</th>
            <th>Ideal</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Connection Available</td>
            <td>
              {data?.facilities?.electricityConnectionAvailable ? "Yes" : "No"}
            </td>
            <td> Yes</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Meter Type</td>
            <td>
              {(data?.facilities?.electricityMeterType &&
                CamelCaseToFirstUpper(
                  data?.facilities?.electricityMeterType
                )) ||
                "N/A"}
            </td>
            <td>Agriculture</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Meter Phase Type</td>
            <td>
              {(data?.facilities?.electricityMeterPhaseType &&
                CamelCaseToFirstUpper(
                  data?.facilities?.electricityMeterPhaseType
                )) ||
                "N/A"}
            </td>
            <td> Both</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Outage Frequency</td>
            <td>
              {(data?.facilities?.electricityOutageFrequency &&
                CamelCaseToFirstUpper(
                  data?.facilities?.electricityOutageFrequency
                )) ||
                "N/A"}
            </td>
            <td> Never</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Usage</td>
            <td>
              {(data?.facilities?.electricityUsage &&
                CamelCaseToFirstUpper(data?.facilities?.electricityUsage)) ||
                "N/A"}
            </td>
            <td> Hydroponics Only</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Pricing Model</td>
            <td>
              {(data?.facilities?.electricityPricingModel &&
                CamelCaseToFirstUpper(
                  data?.facilities?.electricityPricingModel
                )) ||
                "N/A"}
            </td>
            <td>Uniform</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Unit Price</td>

            <td>
              {data?.facilities?.electricityUnitPrice
                ? `₹${data?.facilities?.electricityUnitPrice}`
                : "N/A"}
            </td>
            <td> Below ₹8</td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      {/* <%= render partial: "pdf_cl_quotations/possible_dimensions" %>
    <% if si.cl_project.cl_quotation&.calculator&.has_any_project_size_polyplan_image? %>
    <%= render partial: "pdf_project_report/polyplan_design", locals: { si: si, calculator: si.cl_project.cl_quotation.calculator } %>
  <% end %> */}
      {/* <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div> */}
      {/* <%= render partial: "pdf_project_report/products", locals: { si: si } %> */}
      {/* <% if si.cl_project.cl_quotation.present? %>
    <hr style="margin: 20px 0"/>
    <%= render partial: "pdf_cl_quotations/project_financials",
      locals: { record: si.cl_project.cl_quotation } %>
  <% end %>
   */}
      {/* <%# hidden for now %>
  <% if false && si.cl_project.cl_quotation.present? && si.tentative_start_date.present? %>
    <hr style="margin: 20px 0"/>
    <%= render partial: "pdf_project_report/month_on_month_breakdown", locals: { si: si } %>
  <% end %> */}
    </div>
  );
};

export default SIDetails;
